import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const AdminIntelligenceDashboard = withLazyFallback(
  () => import('components/admin/pages/Intelligence/AdminIntelligenceDashboard')
);
const AdminIntelligenceAiTask = withLazyFallback(
  () => import('components/admin/pages/Intelligence/AiTask/AdminIntelligenceAiTask')
);
const AdminIntelligenceModelTable = withLazyFallback(
  () => import('components/admin/pages/Intelligence/Model/AdminIntelligenceModelTable')
);
const AdminIntelligencePrompts = withLazyFallback(
  () => import('components/admin/pages/Intelligence/Prompt/AdminIntelligencePrompts')
);

const ADMIN_INTELLIGENCE = [
  {
    path: 'intelligence',
    element: <AdminIntelligenceDashboard />,
    children: [
      { path: 'ai_tasks', element: <AdminIntelligenceAiTask /> },
      { path: 'models', element: <AdminIntelligenceModelTable /> },
      { path: 'prompts', element: <AdminIntelligencePrompts /> }
    ]
  }
];

export default ADMIN_INTELLIGENCE;
